export default {
  updateBillingCard: 'Update billing method',
  first_alert: {
    headline: 'Due to refund activity, your account has a negative balance.',
    message: 'We attempted to charge the billing card on file, but it failed. Please take a moment to update your payment method. {{children}}',
  },
  second_alert: {
    headline: 'Due to refund activity, your account has a negative balance.',
    message: 'We attempted to charge the billing card on file, but it failed. Update your billing method to resolve this issue. If this matter is not resolved, your account may be suspended. {{children}}',
  },
  third_alert: {
    headline: 'Your account is at risk of suspension due to a negative balance.',
    message: 'We attempted to charge the billing card on file, but it failed. Update your billing method to resolve this issue. {{children}}',
  },
  learnMore: 'Learn more about negative balances.',
};
